// import appLocaleData from 'react-intl/locale-data/en';
import enMessages from '../locales/en_US';
import myAdminENMessages from '../locales/my-admin-en_US';
import advENMsg from '../locales/adv-en_US';
import asmENMsg from '../locales/asm-en_US';
import evaENMsg from '../locales/eva-en_US';
import grdENMsg from '../locales/grd-en_US';
import tncENMsg from '../locales/tnc-en_US';
import tnfENMsg from '../locales/tnf-en_US';
import curEnMessages from '../locales/cur-en_US'

const EnLang = {
    messages: {
        ...enMessages, 
        ...myAdminENMessages,
        ...advENMsg,
        ...asmENMsg,
        ...evaENMsg,
        ...grdENMsg,
        ...tncENMsg,
        ...tnfENMsg,
        ...curEnMessages,
    },
    locale: 'en-US',
    // data: appLocaleData
};
export default EnLang;
